import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, CardMedia, Typography, List, ListItem, ListItemText, Grid, Paper, Tabs, Tab, ListItemAvatar, Avatar } from "@mui/material";
import { useLocation } from "react-router-dom";
import ReusableHeadingComponents from "../../components/reusableComponents/reusableHeadingComponents";
import { useHistory } from "react-router-dom";
import ReusableButton from "../../components/reusableComponents/reusableButtonComponents";
import ApiService from "../../_services/ApiService";
import ReusableCardView from "../../components/reusableComponents/ReusableCardView";
import NoResults from "../../components/reusableComponents/NoResults";
import SingleDataCard from "../../components/reusableComponents/SingleDataCard";
import D3LineChart from "../../components/reusableComponents/D3LineChart";
import { CardSkeletonCollab, CardSkeletonCount } from "../../components/reusableComponents/SkeletonCard";
import { getDateAsPerFormat } from "../../_helpers/reusablefunctions/dateSetter";
import InternTableView from "./internTableView";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PersonIcon from '@mui/icons-material/Person';
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffOutlined';
import ReusableTabs from "../../components/reusableComponents/reusableTabs";
import { formatCardData, getCurrentMonthAndWeek, transformData } from "../../components/reusableComponents/formatCardData";
import TableComponent from "../../components/reusableComponents/Tablecomponent";
import TablecomponentAnalytics from "../../components/reusableComponents/TablecomponentAnalytics";
import PaymentsIcon from '@mui/icons-material/Payments';
import DynamicToggleTabs from "../../components/reusableComponents/DynamicToggleTabs";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);


const iconsStyle = { fontSize: '20px', color: '#F14950', marginRight: '5px' }

// Application tab is intentionally omitted — internship has no applicants view yet
const internshipTabList = [
    { value: 0, label: 'Details' },
    { value: 1, label: 'Analytics' },
]

const ViewInternshipManagement = () => {
    const history = useHistory();
    const location = useLocation()?.state;
    const locationEventDetail = location?.eventData
    const [loader, setLoader] = useState(false);
    const [offerViewList, setOfferViewList] = useState(locationEventDetail);
    const [value, setValue] = React.useState(0);
    const [formattedData, setFormattedData] = useState();
    const [chartData, setChartData] = useState([]);
    const [chartDataApply, setChartDataApply] = useState([]);
    const [chartDataCreator, setChartDataCreator] = useState([]);
    const [chartDataApplyCreator, setChartDataApplyCreator] = useState([]);
    const { month, week } = getCurrentMonthAndWeek();
    const [chartFullData, setChartFullData] = useState([]);
    const [chartFullDataApply, setChartFullDataApply] = useState([]);
    const [chartFullDataCreator, setChartFullDataCreator] = useState([]);
    const [chartFullDataApplyCreator, setChartFullDataApplyCreator] = useState([]);
    const [revnueValue, setRevnueValue] = useState('Youth');

    const campaignAttributes = [
        { id: '1', label: 'Date posted', value: getDateAsPerFormat(locationEventDetail?.created_at, 'DD Mon, YYYY') || '-', icons: <CalendarMonthIcon sx={iconsStyle} /> },
        { id: '2', label: 'DeadLine Date', value: locationEventDetail?.DeadLineDate || '-', icons: <CalendarMonthIcon sx={iconsStyle} />, },
        { id: '3', label: 'Employment type', value: locationEventDetail?.TypesEmployment || '-', icons: <PersonIcon sx={iconsStyle} />, },
        { id: '4', label: 'Work mode', value: locationEventDetail?.TypesWorkplace || '-', icons: <ToggleOffOutlinedIcon sx={iconsStyle} />, },
        {
            id: '5', label: 'Stipend Amount', value: locationEventDetail?.StipendAmount
                ? `${locationEventDetail?.StipendAmount} / month`
                : '-', icons: <PaymentsIcon sx={iconsStyle} />,
        },
        { id: '6', label: 'Working schedule', value: locationEventDetail?.WorkingSchedule || '-', icons: <ToggleOffOutlinedIcon sx={iconsStyle} />, },
        { id: '7', label: 'Experience', value: locationEventDetail?.TotalExperience || '-', icons: <ToggleOffOutlinedIcon sx={iconsStyle} />, }

    ]

    const backClickHistory = () => {
        history.push('/internship')
    }

    // -----------------
    useEffect(() => {
        setLoader(true);

        Promise.all([
            ApiService.get(
                'offerApplicantClick',
                { month, week },
                `click_analytics/internship/${locationEventDetail?.id}/students`
            ),
            ApiService.get(
                'offerApplicantClick',
                { month, week },
                `apply_analytics/internship/${locationEventDetail?.id}/students`
            ),
            ApiService.get(
                'offerApplicantClick',
                { month, week },
                `click_analytics/internship/${locationEventDetail?.id}/creators/`
            ),
            ApiService.get(
                'offerApplicantClick',
                { month, week },
                `apply_analytics/internship/${locationEventDetail?.id}/creators/`
            )
        ])
            .then(([offerRes, applyRes, offerCreatRes, applyCreatRes]) => {
                if (
                    (offerRes?.status === 200 || offerRes?.status === 201) &&
                    (applyRes?.status === 200 || applyRes?.status === 201) &&
                    (offerCreatRes?.status === 200 || offerCreatRes?.status === 201) &&
                    (applyCreatRes?.status === 200 || applyCreatRes?.status === 201)
                ) {
                    const formattedCardData = formatCardData([
                        { label: 'Youth Clicks', count: offerRes?.data?.data?.total_clicks },
                        { label: 'Number of Youth', count: applyRes?.data?.data?.total_applied },
                        // { label: '', count: null },
                        // { label: ' ', count: null },
                    ]);
                    setChartFullData(offerRes?.data?.data)
                    setChartFullDataApply(applyRes?.data?.data)
                    setFormattedData(formattedCardData);
                    const transformed = transformData(offerRes?.data?.data?.week_wise);
                    setChartData(transformed);
                    const transformedApply = transformData(applyRes?.data?.data?.applications_by_week);
                    setChartDataApply(transformedApply);

                    setChartFullDataCreator(offerCreatRes?.data?.data);
                    setChartFullDataApplyCreator(applyCreatRes?.data?.data);
                    const transformedCreator = transformData(offerCreatRes?.data?.data?.week_wise);
                    setChartDataCreator(transformedCreator);
                    const transformedApplyCreator = transformData(applyCreatRes?.data?.data?.applications_by_week);
                    setChartDataApplyCreator(transformedApplyCreator);
                }
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            })
            .finally(() => setLoader(false));
    }, [month, week, locationEventDetail?.id]);

    // --------- switch tab for analytics
    const handleTabSelect = (newValue) => {
        const tabValue = newValue === 1 ? 'Creators' : 'Youth';
        setRevnueValue(tabValue)
    };

    const shortTimeAgo = (date) => {
        const seconds = Math.floor((new Date() - new Date(date)) / 1000);

        const intervals = [
            { label: "year", seconds: 31536000 },
            { label: "month", seconds: 2592000 },
            { label: "week", seconds: 604800 },
            { label: "day", seconds: 86400 },
            { label: "hour", seconds: 3600 },
            { label: "minute", seconds: 60 },
        ];

        for (const interval of intervals) {
            const count = Math.floor(seconds / interval.seconds);
            if (count >= 1) return `${count} ${interval.label} ago`;
        }

        return "Just now";
    };

    return (
        <Box p={4}>
            <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} >
                <ReusableHeadingComponents bacHistory={true} clickHandlerBack={backClickHistory} heading={`${offerViewList?.Title}`} />
            </Box>
            {/* --------------- cards ------------ */}
            <Box sx={{ display: 'flex', gap: '20px' }}>
                {loader ? (
                    ['', '', '', ''].map((d, i) => (
                        <Grid item xs={12} sm={12} md={12} lg={12} key={i}>
                            <CardSkeletonCount />
                        </Grid>
                    ))
                ) : (formattedData && formattedData.map((item, index) => (
                    <SingleDataCard
                        key={index}
                        cardHeading={item.label}
                        count={item.value}
                        bg={item.bgcolor}
                        cardbg={item.cardbg}
                        Icon={item.Icon}
                        iconColor={item.iconColor}
                    />)
                ))}
            </Box>

            {/* 0---------------- tab switch analytics and offer details ------------- */}

            <Box sx={{ width: '100%', mt: 3 }}>
                <ReusableTabs setValue={setValue} value={value} tabList={internshipTabList} />
            </Box>

            {value == 0 ? <Grid container spacing={2} my={3}>
                <Grid item xs={12} sm={12} md={12} lg={12} >
                    {/* -------- overview ---------------- */}
                    <Card>
                        <Box p={3}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, justifyContent: 'space-between' }}>
                                <Box sx={{ width: 64, height: 64 }}>
                                    <img src={offerViewList?.BrandLogoURL || offerViewList?.BrandLogo} alt="brand logo" style={{ width: 64, height: 64, objectFit: 'contain', borderRadius: 8 }} />
                                </Box>
                                <Box>
                                    <Typography sx={{ color: "#D81921", fontSize: "16px", fontWeight: "bold", mt: 2 }}>
                                        ₹{offerViewList?.StipendAmount} / month
                                    </Typography>
                                    {offerViewList?.updated_at && (<Typography
                                        variant="h6"
                                        sx={{ fontWeight: 400, fontSize: "12px", marginTop: 1, color: "#757575", justifyContent: 'flex-end', display: 'flex' }}
                                    >
                                        {shortTimeAgo(offerViewList?.updated_at)}
                                    </Typography>)}
                                </Box>
                            </Box>
                            <Box mt={2} mb={2} sx={{ borderBottom: "1px solid #E8E8E8" }}>
                                <Box>
                                    <Typography sx={{ color: "#A5A5A5", fontSize: '14px' }}>
                                        {offerViewList?.BrandName}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: '18px', marginTop: 1, color: '#222222', marginBottom: 2 }}>
                                        {offerViewList?.Title}
                                    </Typography>
                                </Box>
                                <Box
                                    display="flex"
                                    flexWrap="wrap"
                                    gap={1}
                                    mt={1}
                                    mb={1.5}
                                >
                                    {campaignAttributes.map((item) => (
                                        <Box
                                            key={item.id}
                                            display="flex"
                                            alignItems="center"
                                            sx={{
                                                background: "#FFF5F5",
                                                color: "#F14950",
                                                fontSize: "12px",
                                                padding: "4px 8px",
                                                borderRadius: "4px",
                                                fontWeight: 500,
                                            }}
                                        >
                                            <Box sx={{ mr: 0.5, display: "flex", alignItems: "center" }}>
                                                {item.icons}
                                            </Box>
                                            <span style={{ fontWeight: 600, marginRight: 4 }}>
                                                {item.label}:
                                            </span>
                                            {item.value}
                                        </Box>
                                    ))}
                                </Box>
                            </Box>
                            <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: '20px', marginBottom: 2 }}>
                                Internship Overview
                            </Typography>
                            {(offerViewList?.Featured_Banner_URL || offerViewList?.Featured_Banner) && (<Box>
                                <Typography sx={{ color: "#000000", fontSize: "18px", fontWeight: "bold", mb: 1 }}>
                                    Banner Image
                                </Typography>
                                <Box sx={{ height: 185, width: 385 }}>
                                    <img src={offerViewList?.Featured_Banner_URL || offerViewList?.Featured_Banner} className="w-100 h-100 object-fit-contain" />
                                </Box>
                            </Box>)}

                            {offerViewList?.JobDescription && (<Box mt={2}>
                                <Typography sx={{ color: "#000000", fontSize: "18px", fontWeight: "bold", mb: 1 }}>
                                    Job description
                                </Typography>
                                <Typography variant="span" sx={{ fontWeight: 'normal', color: "#7A7A7A" }} dangerouslySetInnerHTML={{ __html: offerViewList?.JobDescription }} />
                            </Box>)}

                            <Box>
                                {offerViewList?.SkillsList_display && (<Box>
                                    <Typography sx={{ color: "#000000", fontSize: "18px", fontWeight: "bold", mb: 1 }}>
                                        Skills
                                    </Typography>
                                    <Typography variant="span" sx={{ fontWeight: 'normal', color: "#7A7A7A" }} dangerouslySetInnerHTML={{ __html: offerViewList?.SkillsList_display.map(d => d.Name) }} />
                                </Box>
                                )}

                                {offerViewList?.BenefitsList_display && (<Box>
                                    <Typography sx={{ color: "#000000", fontSize: "18px", fontWeight: "bold", mb: 1 }}>
                                        Benefits
                                    </Typography>
                                    <Typography variant="span" sx={{ fontWeight: 'normal', color: "#7A7A7A" }} dangerouslySetInnerHTML={{ __html: offerViewList?.BenefitsList_display.map(d => d.Name) }} />
                                </Box>
                                )}
                                {offerViewList?.InternshipList_display && (<Box>
                                    <Typography sx={{ color: "#000000", fontSize: "18px", fontWeight: "bold", mb: 1 }}>
                                        Department
                                    </Typography>
                                    <Typography variant="span" sx={{ fontWeight: 'normal', color: "#7A7A7A" }} dangerouslySetInnerHTML={{ __html: offerViewList?.InternshipList_display.map(d => d.TypeName) }} />
                                </Box>
                                )}
                            </Box>
                            {offerViewList?.FAQ && (<Box mt={2}>
                                <Typography sx={{ color: "#000000", fontSize: "18px", fontWeight: "bold", mb: 1 }}>
                                    Faq
                                </Typography>
                                <Typography variant="span" sx={{ fontWeight: 'normal', color: "#7A7A7A", fontSize: '16px' }} dangerouslySetInnerHTML={{ __html: offerViewList?.FAQ }}
                                />
                            </Box>)}
                        </Box>
                    </Card>
                </Grid>
                {/* --------- job details ------------
                <Grid item xs={12} sm={12} md={4} lg={4} >
                    <Card>
                        <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                            {campaignAttributes.map(d => (
                                <ListItem key={d.id} sx={{ gap: 2 }}>
                                    {d.icons}
                                    <ListItemText primary={d?.label} secondary={d?.value} />
                                </ListItem>
                            ))}
                        </List>
                    </Card>
                </Grid> */}
                {/* <Grid item xs={12} sm={12} md={12} lg={12} >

                    <ReusableCardView title="FAQ" Component={
                        <Box p={3}>
                            <Typography variant="span" sx={{ fontWeight: 'normal', color: "#7A7A7A", fontSize: '16px' }} dangerouslySetInnerHTML={{ __html: offerViewList?.FAQ }}
                            />
                        </Box>
                    }
                    />
                </Grid> */}
            </Grid >
                :
                <Box>
                    {/* <Box className='d-flex justify-content-end align-items-center flex-wrap'>
                        <DynamicToggleTabs value1="Youth" value2="Creators" onSelectTab={handleTabSelect} revnueValue={revnueValue} />
                    </Box> */}
                    <Grid container spacing={2} mt={2}>

                        <Grid item xs={12} sm={12} md={6} lg={6} >
                            {/* -------- Application Over Time     ---------------- */}
                            <ReusableCardView title="Application Over Time    " Component={
                                (revnueValue === 'Youth' ? chartData : chartDataCreator).length ? <Box >
                                    <D3LineChart
                                        data={revnueValue === 'Youth' ? chartData : chartDataCreator}
                                        xKey={(revnueValue === 'Youth' ? chartData : chartDataCreator)[0]?.day ? "day" : "month"}
                                        yKey="value"
                                        title={`${revnueValue === 'Youth' ? 'Youth' : 'Creator'} Clicks`}
                                        color="#4F46E5"
                                        width={500}
                                        height={250}
                                    // timeFrames={["This week", "This month"]}
                                    // onTimeFrameChange={handleTimeFrameChange}
                                    // timeFrames={timeFrames}
                                    // onTimeFrameChange={(timeFrame) => {
                                    //     setSelectedTimeFrame(timeFrame);
                                    //     // fetchData(selectedMonth, timeFrame === "This Week" ? currentWeek : parseInt(timeFrame.split(" ")[1]));
                                    // }}
                                    />
                                </Box>
                                    :
                                    loader ? (
                                        [''].map((d, i) => (
                                            <Grid item xs={12} sm={12} md={12} lg={12} key={i}>
                                                <CardSkeletonCollab />
                                            </Grid>
                                        ))
                                    ) : null
                            } />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={6} >
                            {/* -------- User Insight  ---------------- */}
                            <ReusableCardView title="User Insight " Component={
                                (revnueValue === 'Youth' ? chartDataApply : chartDataApplyCreator).length ? <Box >
                                    <D3LineChart
                                        data={revnueValue === 'Youth' ? chartDataApply : chartDataApplyCreator}
                                        xKey={(revnueValue === 'Youth' ? chartDataApply : chartDataApplyCreator)[0]?.day ? "day" : "month"}
                                        yKey="value"
                                        title={`${revnueValue === 'Youth' ? 'Youth' : 'Creator'} Applied Applicants`}
                                        color="#4F46E5"
                                        width={500}
                                        height={250}
                                    // timeFrames={["This week", "This month"]}
                                    // onTimeFrameChange={handleTimeFrameChange}
                                    // timeFrames={timeFrames}
                                    // onTimeFrameChange={(timeFrame) => {
                                    //     setSelectedTimeFrame(timeFrame);
                                    //     // fetchData(selectedMonth, timeFrame === "This Week" ? currentWeek : parseInt(timeFrame.split(" ")[1]));
                                    // }}
                                    />
                                </Box> :
                                    loader ? (
                                        [''].map((d, i) => (
                                            <Grid item xs={12} sm={12} md={12} lg={12} key={i}>
                                                <CardSkeletonCollab />
                                            </Grid>
                                        ))
                                    ) : null
                            } />
                        </Grid>

                        {/* -------------------- Applicants table data -------------- */}
                        <Grid item xs={12} sm={12} md={12} lg={12} >
                            {/* <InternTableView /> */}
                            {/* <ReusableCardView title="Internship Clicks" Component={<TablecomponentAnalytics loader={loader} chartData={revnueValue === 'Youth' ? chartFullData : chartFullDataCreator}  title="Clicks" />} /> */}

                            <ReusableCardView title="Internship Applied" Component={<TablecomponentAnalytics loader={loader} chartData={revnueValue === 'Youth' ? chartFullDataApply : chartFullDataApplyCreator} title="Applied" />} />

                        </Grid>
                    </Grid>
                </Box>
            }
        </Box >
    );
};

export default ViewInternshipManagement;
